module.exports = __webpack_public_path__ + "img/green-star-left.e9b85e26.png";